import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ConfigProvider } from "../../../config-provider.service";
import { MobileSidenavService } from '../mobile-header/mobile.sidenav.service';
import { CurrentUser } from '../../providers/current-user';
import { Subscription } from 'rxjs';
import { UtilsProvider } from "../../providers/utils-provider.service";
import { Athlete } from '../../models/athlete';
import { User } from "../../models/user";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { NgIf } from "@angular/common";
import { MatListModule, MatNavList } from "@angular/material/list";
import { MatLineModule } from "@angular/material/core";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
  selector: 'app-mobile-side-menu',
  providers: [],
  styleUrls: ['./mobile.side-menu.component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    NgIf,
    MatLineModule,
    TranslateModule,
    MatListModule,
    RouterLink,
    FlexLayoutModule,
  ],
  templateUrl: './mobile.side-menu.component.html'
})
export class MobileSideMenuComponent implements OnInit, AfterViewInit, OnDestroy {
    public dashboardUrl = '';

    public get menuGroups() {
        return this._menuGroups;
    }
    @Input() public set menuGroups(menuGroups: MenuGroup[]) {
        this._menuGroups = menuGroups;
        this._changeDetector.detectChanges();
    }

    public isMenuVisibleOnSmallScreen = false;
    public currentUrl: string | null = null;
    public athleteUser: User = {} as User;
    public defaultDay: string = '';

    @Input() public neverHide = false;

    private _menuGroups: MenuGroup[] = [];
    private subscriptions: Subscription[] = [];
    private _currentDate: Date = new Date();

    constructor(
        private _utils: UtilsProvider,
        private _route: ActivatedRoute,
        public conf: ConfigProvider,
        private _router: Router,
        private _changeDetector: ChangeDetectorRef,
        private sideNaveService: MobileSidenavService,
        public currentUser: CurrentUser,
    ) {
    }

    public ngOnInit(): void {
        this.defaultDay = this._utils.DateToYmd(this._currentDate);
        this.subscriptions.push(
            this._route.data.subscribe((data: any) => {//{ organization: Organization; athlete: Athlete }
                this.athleteUser = data.athlete;
                this.dashboardUrl = data.organization.code + '/app/athletes/' + data.athlete.id;
            })
        );

        this.subscriptions.push(
            this.sideNaveService.toggleSidenav.subscribe(() => {
                this.onToggleMenuClicked();
            })
        );
    }

    public ngAfterViewInit() {
        this.currentUrl = this._router.url;
        this._changeDetector.detectChanges();
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public onToggleMenuClicked(event: any = null): void {
        if (event) {
            event.stopPropagation();
        }

        this.isMenuVisibleOnSmallScreen = !this.isMenuVisibleOnSmallScreen;
    }

    public onLogoutClicked(): void {
        this._router.navigate(['logout']);
    }

    public onHeaderClicked() {
        this._router.navigateByUrl(this.dashboardUrl);
    }
}

export interface MenuGroup {
    title: string;
    menus: MenuItem[];
}

export interface MenuItem {
    title: string;
    icon: string;
    url?: string;
    onClicked?: any;
}
